import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Thalia_Title } from '../../../../../utils/ES/Modals/VideoModals';

const ModalVideoThalia = () => {
  return (
    <>
      <ModalVideo
        id="thalia-videoclips"
        dataText={Thalia_Title}
        videoSrc="https://player.vimeo.com/video/167160437?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_THALIA"
      />
    </>
  );
};

export default ModalVideoThalia;
